<template>
    <div id="signin_wrapper">
        <v-dialog 
            v-model="activateUserDialog" 
            width="40%"
            elevation="8"
            persistent>
                <ActivateUserConfirmation 
                    :selectedUser="selectedUser"
                    @updateSwitchState="updateSwitchState"
                    @closeActivateDialog="closeActivateDialog" />
        </v-dialog> 

        <v-form v-model="secondary_user_valid" ref="secondary_user">                            
            <v-row class="mt-1">
                <v-col>
                    <div v-if="thisUser.id == null && users_for_parent.length && !selectedUser.length && !create_new_user">
                        <v-select 
                            v-model="selectedUser"
                            :items="users_for_parent"
                            label="Select an Existing User"
                            outlined
                            class="mt-6"
                            @change="populateSelectedUser()">
                            <template v-slot:append-item>
                                <v-list-item @click="createNewUser()">Add a New User to the Project</v-list-item>
                            </template>
                        </v-select>

                        
                        <div v-if="!create_new_user && Object.keys(selectedUser).length > 0 && !selectedUser.is_active" class="d-flex d-block mb-1">
                            <div class="d-inline mr-1">This user is not active, toggle to activate before submitting.</div>
                            <v-switch
                                v-model="switch_state"
                                color="primary"
                                class="d-inline justify-end ma-0 pa-0 grey--text"
                                hide-details
                                @click="activateUserDialog = true">
                            </v-switch>
                        </div>
                    </div>

                    <div v-if="thisUser.id != null || users_for_parent.length == 0 || create_new_user || selectedUser.length">
                        <div class="d-block sansation mb-1">First Name</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model="thisUser.newuser_firstname" 
                                solo 
                                :rules="firstnameRules"
                                required>
                            </v-text-field>
                        </div>

                        <div class="d-block sansation mb-1">Last Name</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model="thisUser.newuser_lastname" 
                                solo 
                                :rules="lastnameRules"
                                required>
                            </v-text-field>
                        </div>
                        
                        <div class="d-block sansation mb-1">Email</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model.lazy="thisUser.newuser_email" 
                                solo 
                                :rules="emailRules" 
                                required
                                :disabled="thisUser.id != undefined">
                            </v-text-field>                                    
                        </div>
                    </div>
                </v-col>

                <v-col class="pl-9">
                    <v-checkbox
                        v-for="(permissions, ndx) in userPermissions"
                        :key="ndx"
                        v-model="thisUser.user_permissions"
                        :label="permissions.text"
                        :value="permissions.value"
                        color="primary"
                        class="ml-6"
                        hide-details>
                    </v-checkbox>

                    <!-- <div class="d-block mt-12 pt-5 ml-6 sansation">Expiration Date</div> -->

                    <div class="d-block mt-12 pt-3 ml-6">
                        <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="computedExpirationFormatted"
                                    label="Expiration Date"
                                    hide-details
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="thisUser.expiration_date"
                                @input="dateMenu = false"
                                @change="userExpires()">
                            </v-date-picker>
                        </v-menu>

                        <div class="d-flex justify-end">
                            <div class="d-inline mr-3 mt-5">Never Expires</div>
                            <v-checkbox
                                v-model="thisUser.never_expires"
                                color="primary"
                                class="d-inline mr-n2"
                                @click.stop="neverExpires()"
                                hide-details>
                            </v-checkbox>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-divider></v-divider> 
            <v-row class="mt-1">
                <v-col class="d-flex justify-end">
                    <div class="d-flex d-block justify-end align-center mr-4 pr-0">
                        <div class="d-inline mr-1">Generate Email:</div>
                        <v-checkbox
                            v-model="generate_email_on_add"
                            hide-details
                            color="primary"
                            class="d-inline ma-0 pa-0 mr-n2">
                        </v-checkbox>
                    </div>
                    <v-btn 
                        color="primary" 
                        class="mr-3 d-inline"
                        outlined 
                        id="login_btn" 
                        @click="resetClear" >
                        reset
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        class="d-inline"
                        :disabled="create_new_user == false && Object.keys(selectedUser).length > 0 && !selectedUser.is_active" 
                        id="login_btn" 
                        @click="thisUser.id != undefined ? editSecondaryUser() : createSecondaryUser()" >
                        {{ submit_text }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';
    
    import ActivateUserConfirmation from './dialogs/ActivateUserConfirmation.vue'
    
    export default {
        name: 'SecondaryUser',

        components: {
            ActivateUserConfirmation
        },

        props: {
            project: Object,
            thisUser: Object,
            formatThisDate: Function,
            secondaryUserDialog: Boolean,
            resetCreateNewUser: Boolean,
            refreshUsers: Function,
        },

        data () {
            return {
                alertDuration: 8000,
                secondary_user_valid: false,
                submit_text: 'Submit',
                firstnameRules: [
                    (v) => !!v || 'First Name is required'
                ],
                lastnameRules: [
                    (v) => !!v || 'Last Name is required'
                ],
                passRules: [
                    (v) => !!v || 'Password is required',
                    (v) => v.length >= 8 || 'Password must be at least 8 charaters long.'
                ],
                emailRules: [
                    (v) => !!v || 'Email is required',
                    (v) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/.test(v) || 'Email must be in valid format'
                ],
        
                userPermissions: [
                    { text: "View All Questionnaire Data", value: "r" },
                    { text: "Edit All Questionnaire Data", value: "w" },
                    { text: "View SRG Provided Deliverables", value: "x" }
                ],
                dateMenu: false,
                create_new_user: false,
                users_for_parent: [],
                selectedUser: {},
                generate_email_on_add: true,
                activateUserDialog: false,
                switch_state: false
            }
        },
        
        mounted() {
            this.pullCurrentUsers()
        },

        watch: {
            project(val) {
                this.resetClear()
            },
            resetCreateNewUser(val) {
                if ( val ) {
                    this.resetClear()
                }
            }
        },

        computed: {
            computedExpirationFormatted: {
                get: function() {
                    return this.thisUser.expiration_date != '' ? this.formatDateForDB(this.thisUser.expiration_date+' 09:00:00') : '';
                },
                set: function(val) {
                    return val;
                }
            },
            projectOwners () {
                return this.project.users.filter( user => user.user_type == 'owner' )
            },
            projectSecondaryUsers () {
                return this.project.users.filter( user => user.user_type == 'secondary' )
            },
            projectPartners () {
                return this.project.users.filter( user => user.user_type == 'partner' )
            }
        },

        methods: {
            createNewUser () {
                this.create_new_user = true
            },

            formatDateForDB: function ( date ) {
                if (!date) return '';
                
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }
                return this.formatThisDate(date, options, true)
            },

            formatDateToTime: function ( date ) {
                if (!date) return 0;
                
                const date_to_time = new Date(date).getTime();
                
                return date_to_time;
            },

            neverExpires: function () {
                this.thisUser.never_expires = true
                // console.log(this.thisUser.never_expires)
                this.computedExpirationFormatted = 
                this.thisUser.expiration_date = '';
            },

            userExpires: function () {
                this.thisUser.never_expires = false;
            },

            pullCurrentUsers: async function () {
                try {
                    const ownerIds = this.projectOwners.map( owner => {
                        return owner.user_id
                    })

                    const all_secondary_users = await axios.post(`${appUrls.api}/api/users_for_parent`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        ownerIds
                    })

                    if ( all_secondary_users.data.outcome ) {
                        let nonreducedSecondaryUsers=[]
                        this.projectOwners.forEach(owner => {
                            all_secondary_users.data.users.forEach(usr => {
                                if (usr.parent_user_id === owner.user_id) {
                                    const key = `${usr.first_name} ${usr.last_name}`
                                    nonreducedSecondaryUsers.push({ text: key, value: usr })
                                }
                            })
                        })

                        const currentSecondarys = this.projectSecondaryUsers.map( usr => {
                            return usr.user_id
                        })

                        this.users_for_parent = nonreducedSecondaryUsers.reduce((acc, user) => {
                            const userId = user.value.user_id
                            if ( !acc.ids.has(userId) && !currentSecondarys.includes(userId) ) {
                                acc.ids.add(userId);
                                acc.users.push(user);
                            }
                            return acc;
                        }, { ids: new Set(), users: [] }).users;
                        
                        // console.log(this.users_for_parent)
                    } else {
                        console.log(all_secondary_users.data.message)
                    }                    
                } catch ( error ) {
                    console.log(error);
                    // this.$emit("addUserFeedback", { outcome: false, message: error });
                }
            },

            populateSelectedUser: function () {
                // console.log(this.selectedUser)
                this.thisUser.user_id = this.selectedUser.user_id
                this.thisUser.parent_user_id = this.selectedUser.parent_user_id
                this.thisUser.newuser_firstname = this.selectedUser.first_name
                this.thisUser.newuser_lastname = this.selectedUser.last_name
                this.thisUser.newuser_email = this.selectedUser.user_email
                this.thisUser.newuser_type = this.selectedUser.user_type,
                this.thisUser.user_permissions = ['r', 'w']
                this.thisUser.expiration_date = ''
                this.thisUser.never_expires = true
                // console.log(this.thisUser)
            },

            createSecondaryUser: async function () {
                try {
                    // this.$refs.secondary_user.validate();
                    if ( this.secondary_user_valid ) {
                        const add_project_user = await axios.post(`${appUrls.api}/api/add_project_user`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data: {
                                user_id: this.thisUser.user_id,
                                parentUserId: this.project.user_id,
                                projectId: this.project.project_id,
                                newuser_firstname: this.thisUser.newuser_firstname,
                                newuser_lastname: this.thisUser.newuser_lastname, 
                                newuser_email: this.thisUser.newuser_email,
                                newuser_type: this.thisUser.newuser_type,
                                newuser_group: this.thisUser.newuser_type,
                                user_permissions: this.thisUser.user_permissions,
                                expiration_date: this.thisUser.expiration_date != '' ? this.formatDateToTime(this.thisUser.expiration_date) : null, // adding the time helps create the correct unix timestamp
                                never_expires: this.thisUser.never_expires,
                                generate_email: this.generate_email_on_add
                            }
                        })

                        if ( add_project_user.data.outcome ) {
                            // console.log('secondary_users emit refresh')
                            this.$emit('refreshUsers', this.project.project_id, add_project_user.data.message) // change in "refreshUsers" method
                            this.resetClear()
                        } else {
                            console.log(add_project_user.data.message)
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                    // this.$emit("addUserFeedback", { outcome: false, message: error });
                }
            },

            editSecondaryUser: async function () {
                try {
                    // this.$refs.secondary_user.validate();
                    if ( this.secondary_user_valid ) {
                        const edit_project_user = await axios.post(`${appUrls.api}/api/edit_project_user`, { // make changes in server
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data: {
                                id: this.thisUser.id,
                                user_id: this.thisUser.user_id,
                                newuser_firstname: this.thisUser.newuser_firstname,
                                newuser_lastname: this.thisUser.newuser_lastname,
                                newuser_email: this.thisUser.newuser_email,
                                newuser_type: this.thisUser.newuser_type,
                                user_permissions: this.thisUser.user_permissions,
                                expiration_date: this.thisUser.expiration_date != '' ? this.formatDateToTime(this.thisUser.expiration_date) : null,
                                never_expires: this.thisUser.never_expires,
                                generate_email: this.generate_email_on_add
                            }
                        })
                        
                        if ( edit_project_user.data.outcome ) {
                            this.$emit('refreshUsers', this.project.project_id, edit_project_user.data.message) // change in "refreshUsers" method
                            this.resetClear()
                        } else {
                            console.log(edit_project_user.data.message)
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },
            
            resetClear () {
                this.thisUser.user_id = null
                this.thisUser.newuser_firstname = ''
                this.thisUser.newuser_lastname = '' 
                this.thisUser.newuser_email = ''
                this.thisUser.newuser_type = ''
                this.thisUser.user_permissions = ['r','w']
                this.thisUser.expiration_date = ''
                this.thisUser.never_expires = true
                this.generate_email_on_add = true

                this.create_new_user = false
                this.selectedUser = {}
            },

            closeActivateDialog: function ( val ) {
                this.activateUserDialog = val
            },

            updateSwitchState: function ( val ) {
                this.switch_state = val
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #signin_wrapper {
        width: 100%;
        height: 100%;
    }
    #login {
        min-width: 100%;
        max-width: 100%;
        margin: 2% auto;
        padding: 9%;
        text-align: center;
        font-size: .8rem;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 8px;
    }
    #login_btn {
        padding: 4px 20px;
        /* width: 36%; */
        font-size: 1.2em !important;
    }
    .mnt_image {
        background-position: top left; 
        background-repeat: no-repeat; 
        background-attachment: fixed; 
        background-size: cover;
    }
    .return_link {
        font-size: 1.25rem;
        text-decoration: none;
        /* mdi-keyboard-backspace */
    }
    .signin_title {
        /* color: #37383C; */
        font-weight: 600;
        font-size: 1.6rem !important;
        letter-spacing: 0.05rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/SecondaryUser.vue